module.exports = __webpack_public_path__ + "media/images/drag_and_drop_hexagon-2df7708da1f8b54d36b8b03ccb5b2a53.svg";